import { createTheme, type PaletteMode } from "@mui/material/styles";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#4F46E5", dark: "#3730A3", light: "#6366F1" },
            secondary: { main: "#10B981" },
            error: { main: "#EF4444" },
            background: { default: "#F9FAFB", paper: "#FFFFFF" },
          }
        : {
            primary: { main: "#818CF8", dark: "#4F46E5", light: "#A5B4FC" },
            secondary: { main: "#34D399" },
            error: { main: "#EF5350" },
            background: { default: "#111827", paper: "#1F2937" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 8,
            fontWeight: 500,
          },
        },
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            border: "1px solid",
            borderColor: mode === "light" ? "#E5E7EB" : "#374151",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            "&.Mui-selected": {
              backgroundColor:
                mode === "light"
                  ? "rgba(79, 70, 229, 0.1)"
                  : "rgba(129, 140, 248, 0.15)",
              color: mode === "light" ? "#4F46E5" : "#818CF8",
              "&:hover": {
                backgroundColor:
                  mode === "light"
                    ? "rgba(79, 70, 229, 0.15)"
                    : "rgba(129, 140, 248, 0.2)",
              },
            },
          },
        },
      },
    },
  });
}
